import React, { useEffect, useState } from 'react';

const Countdown = ({ targetDate }) => {
  const calculateTimeLeft = () => {
    const difference = new Date(targetDate) - new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const addLeadingZero = value => {
    return value.toString().padStart(2, '0');
  };

  return (
    <div style={{backgroundColor:"#18191D"}}>
      {timeLeft.days && <span>{addLeadingZero(timeLeft.days)}:</span>}
      <span>{addLeadingZero(timeLeft.hours)}:</span>
      <span>{addLeadingZero(timeLeft.minutes)}:</span>
      <span>{addLeadingZero(timeLeft.seconds)}</span>
    </div>
  );
};

export default Countdown;